(function (w, $) {
    'use strict';

    function checkout(paymentId, $container, controller) {
        var _paymentId = paymentId;
        var _$container = $container;
        var _controller = controller;
        var _sveaOrderId = null;

        document.addEventListener('checkoutReady', function () {
            window.scoApi.observeEvent('identity.postalCode', function (data) {
                console.log('PostalCode changed to %s.', data.value); 
                _controller.updateOrder();
            });
            window.scoApi.observeEvent('identity.city', function (data) {
                console.log('City changed to %s.', data.value); 
                _controller.updateOrder();
            });
        });

        return {
            getPaymentId: function () { return _paymentId; },
            getSpecifics: function () {
                return {
                    name: 'Svea',
                    canDisableDeliveryPostalCode: false
                };
            },
            getOrderFormValues: function () {
                var orderForm = {};
                return orderForm;
            },
            suspendForUpdate: function () {
                // parent control (212) blocks the UI - no need to suspend here
            },
            handleUpdatedOrder: function (checkoutOrder) {
                if (w.scoApi && w.scoApi.setCheckoutEnabled && _sveaOrderId === checkoutOrder.SveaOrderID) {
                    w.scoApi.setCheckoutEnabled(false); // suspend and resume to make the frame refresh itself
                    w.scoApi.setCheckoutEnabled(true);
                } else {
                    _$container.empty();
                    _$container.append(checkoutOrder.CheckoutHtmlSnippet);
                    _sveaOrderId = checkoutOrder.SveaOrderID;
                }
            }
        };
    }

    if (!w.checkoutProviders) {
        w.checkoutProviders = {};
    }

    w.checkoutProviders.svea = checkout;

})(window, jQuery);